import { DomHelper } from "./domHelper";
import { getBackendData } from "./xhrbackend";
import { Util } from "./util";
import { API_URL, DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
export function appTimetableRender(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appTimetableRender");
    const additionalClassList = ['full-width-interaction'];
    if (userResponse.pupil) {
        getBackendData(userResponse.pupil.schoolUUID + "/" + userResponse.pupil.odClassUUID + "/timetable", "/school/", "GET", "application/json", bearerToken, appTimetablePartRender);
    }
    else {
        console.log("no profile render");
        return;
    }
    let content = "";
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    cardNode.classList.remove("rudi-max-height");
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-timetable');
        injectNode.innerHTML = content;
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
}
export function appTimetableUploadRender(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appTimetableUploadRender");
    const additionalClassList = ['full-width-interaction'];
    getBackendData(username, "/school/", "GET", "application/json", bearerToken, function (event) {
        appTimetableUploadPartRender(event, bearerToken);
    });
    let content = "";
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, userResponse.username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList);
    let appNode = DomHelper.getFirstParentWithClass(cardNode, "rudi-app");
    if (appNode)
        appNode.classList.remove('rudi-max-height');
    let injectNodes = cardNode.getElementsByClassName('rudi-app-inject');
    const injectNode = injectNodes.item(0);
    if (injectNode) {
        injectNode.classList.remove('rudi-app-inject');
        injectNode.classList.add('rudi-app-interaction');
        injectNode.setAttribute("id", 'rudi-timetable-upload');
        injectNode.innerHTML = content;
    }
    else {
        console.log("Couldn't get Element to add Profile content");
    }
    DomHelper.appendSpinner(injectNode);
}
function appendTimeElement(parent, timeItem, cssClassTR) {
    const trNode = DomHelper.appendNode(parent, 'tr', cssClassTR);
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-tag'], [], Util.timeStamp2DayString(timeItem.von));
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-von'], [], Util.timeStamp2TimeString(timeItem.von));
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-bis'], [], Util.timeStamp2TimeString(timeItem.bis));
    DomHelper.appendNode(trNode, 'td', ['rudi-tt-subject'], [{ attr: "alt", value: timeItem.subject }], timeItem.subject);
    DomHelper.appendNode(trNode, 'td', ['rudi-tt-teacher'], [], timeItem.teacher);
    DomHelper.appendNode(trNode, 'td', ['rudi-tt-room'], [], timeItem.room);
}
function appendTimeTableHeader(parent) {
    const trNode = DomHelper.appendNode(parent, 'thead', ['thead-dark']);
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-tag'], [], "Tag");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-von'], [], "Beginn");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-bis'], [], "Ende");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-subject'], [], "Fach/Thema");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-teacher'], [], "Lehrer_in");
    DomHelper.appendNode(trNode, 'th', ['rudi-tt-room'], [], "Raum");
}
function appTimetablePartRender(response) {
    if (DEBUG)
        console.log("-->appTimetablePartRender");
    const ttNode = document.getElementById("rudi-timetable");
    if (ttNode) {
        ttNode.classList.remove("disabled");
        let listNode = DomHelper.appendNode(ttNode, 'table', ['table', 'rudi-tt-list']);
        appendTimeTableHeader(listNode);
        console.log(response);
        if (response != null) {
            const timetable = JSON.parse(response.target.response);
            let cssClass = ['odd'];
            let lastDate;
            for (const timeItem of timetable) {
                const vonDate = new Date(timeItem.von);
                if (lastDate && vonDate.getDate() != lastDate) {
                    cssClass = cssClass.indexOf('even') >= 0 ? ['odd'] : ['even'];
                    lastDate = vonDate.getDate();
                }
                else if (!lastDate) {
                    lastDate = vonDate.getDate();
                }
                appendTimeElement(listNode, timeItem, cssClass);
            }
        }
    }
}
function appTimetableUploadPartRenderClassSelect(response, bearerToken) {
    const classes = JSON.parse(response.target.response);
    const activeClasses = Util.filterActiveClasses(classes);
    const selectNode = document.getElementById('rudi-tt-form-school-class');
    if (selectNode) {
        selectNode.innerHTML = "";
        DomHelper.appendNode(selectNode, 'option', [], [
            { attr: 'value', value: '' },
            { attr: 'selected', value: 'true' },
            { attr: 'disabled', value: 'true' },
            { attr: 'hidden', value: 'true' }
        ], "Bitte wählen");
        for (let classItem of classes) {
            DomHelper.appendNode(selectNode, 'option', [], [
                { attr: 'value', value: classItem.id }
            ], classItem.longname);
        }
    }
}
function appTimetableUploadPartRender(response, bearerToken) {
    if (DEBUG)
        console.log("-->appTimetableUploadPartRender");
    const ttNode = document.getElementById("rudi-timetable-upload");
    if (ttNode) {
        const schools = JSON.parse(response.target.response);
        ttNode.classList.remove('disabled');
        ttNode.innerHTML = "";
        const formNode = DomHelper.appendNode(ttNode, 'form', [], [
            { attr: 'id', value: 'rudi-tt-upload' },
            { attr: 'enctype', value: 'multipart/form-data' },
            { attr: 'method', value: 'POST' }
        ]);
        const uploadNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
        DomHelper.appendNode(uploadNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'file' }], "Wählen Sie eine Stundenplan-Datei für den Upload");
        const fileInputNode = DomHelper.appendNode(uploadNode, 'input', ['form-control-file'], [
            { attr: 'type', value: 'file' },
            { attr: 'name', value: 'file' },
            { attr: 'id', value: 'file' },
        ]);
        const schoolNode = DomHelper.appendNode(formNode, 'div', ['form-group']);
        DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school' }], "Wählen Sie die Schule für den Upload");
        const selectNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-tt-form-school' }]);
        if (schools.length == 1) {
            selectNode.setAttribute('disabled', 'true');
        }
        else {
            DomHelper.appendNode(selectNode, 'option', [], [
                { attr: 'value', value: '' },
                { attr: 'selected', value: 'true' },
                { attr: 'disabled', value: 'true' },
                { attr: 'hidden', value: 'true' }
            ], "Bitte wählen");
        }
        for (let school of schools) {
            DomHelper.appendNode(selectNode, 'option', [], [
                { attr: 'value', value: school.id }, { attr: 'readonly', value: schools.length == 1 }
            ], school.longname);
        }
        DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school-class' }], "Wählen Sie die Klasse für den Upload");
        const selectClassNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-tt-form-school-class' }]);
        if (schools.length == 1) {
            getBackendData("", `/school/${schools[0].id}/classes`, "GET", "application/json", bearerToken, function (event) {
                appTimetableUploadPartRenderClassSelect(event, bearerToken);
            });
        }
        else {
            selectNode.addEventListener('change', (event) => {
                const selectedValue = event.target.value;
                getBackendData("", `/school/${selectedValue}/classes`, "GET", "application/json", bearerToken, function (event) {
                    appTimetableUploadPartRenderClassSelect(event, bearerToken);
                });
            });
        }
        const buttonNode = DomHelper.appendNode(formNode, 'button', ['btn', 'btn-primary'], [{ attr: 'type', value: 'submit' }, { attr: 'id', value: 'rudi-tt-btn-submit' }, { attr: 'disabled', value: 'true' }], 'Importieren');
        selectNode.addEventListener('change', checkFormValid);
        selectClassNode.addEventListener('change', checkFormValid);
        DomHelper.appendNode(formNode, 'aside', ['hidden'], [{ attr: 'id', value: 'rudi-tt-message' }], '');
        formNode.addEventListener('submit', function (event) {
            appTimetableUploadHandleSubmit(event, bearerToken);
        });
        function checkFormValid() {
            const isSchoolSelected = selectNode.value !== '';
            const isClassSelected = selectClassNode.value !== '';
            const isFileSelected = fileInputNode.files && fileInputNode.files.length > 0;
            buttonNode.disabled = !(isSchoolSelected && isClassSelected && isFileSelected);
        }
    }
}
function appTimetableUploadHandleSubmit(event, bearerToken) {
    if (DEBUG)
        console.log("-->appTimetableUploadHandleSubmit");
    event.preventDefault();
    let schoolid = document.getElementById('rudi-tt-form-school').value;
    let classid = document.getElementById('rudi-tt-form-school-class').value;
    let form = document.getElementById('rudi-tt-upload');
    const formData = new FormData(form);
    const messageNode = document.getElementById('rudi-tt-message');
    if (messageNode)
        messageNode.innerHTML = "";
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${API_URL}/school/${schoolid}/${classid}/upload`, true);
    xhr.setRequestHeader('Authorization', 'Bearer ' + bearerToken);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                console.log('Upload successful');
                const result = JSON.parse(xhr.responseText);
                if (messageNode) {
                    messageNode.classList.remove('hidden');
                    messageNode.classList.add('rudi-status-success');
                    messageNode.innerHTML = `Es wurden ${result.length} Einträge importiert`;
                }
            }
            else {
                console.log('Error', xhr.statusText);
            }
        }
    };
    xhr.send(formData);
}
